// Compare calendar dates in the user's local time zone, without parsing ISO dates as UTC.
export function isValuationStale(date, today = new Date()) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date ?? '')) return false;
    const [year, month, day] = date.split('-').map(Number);
    const valuation = new Date(year, month - 1, day);
    if (valuation.getFullYear() !== year || valuation.getMonth() !== month - 1 || valuation.getDate() !== day) return false;

    const anniversaryYear = year + 1;
    const lastDay = new Date(anniversaryYear, month, 0).getDate();
    const anniversary = new Date(anniversaryYear, month - 1, Math.min(day, lastDay));
    const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return localToday > anniversary;
}
